import { sendTelemetryEvent } from '@fluidx/telemetry';
const userActivityEvents = [
    'mousemove',
    'keydown',
    'wheel',
    'DOMMouseScroll',
    'mouseWheel',
    'mousedown',
    'touchstart',
    'touchmove',
    'MSPointerDown',
    'MSPointerMove',
    'visibilitychange'
];
// TODO: UIHOST: Add unit tests for the UserActivityTracker class to test all the timer logic
/**
 * Tracks user activity and sets the user state to Idle when there is no user activity for a specified period of time.
 */ export class UserActivityTracker {
    /**
   * Is the user currently active?
   */ get isUserActive() {
        return this.isActive;
    }
    /**
   * Disposes the user activity tracker. This will stop listening for user activity/inactivity. Call this when the tracker is no longer needed.
   */ dispose() {
        this.isActive = true;
        clearTimeout(this.userInactiveTimerId);
        userActivityEvents.forEach((value)=>{
            document.removeEventListener(value, this.userActivityCallback, {
                capture: false
            });
        });
    }
    onUserActivityDetected() {
        if (!this.isActive) {
            // State just changed from inactive to active
            this.isActive = true;
            this.onUserActivityStateChange(true);
            // TODO: Task 6915778: Re-evaluate if User Activity telemetry is needed
            this.logger && sendTelemetryEvent(this.logger, {
                eventName: 'UserActive'
            });
        }
        this.resetUserInactiveTimer();
    }
    // Reset the timer to track user activity.
    resetUserInactiveTimer() {
        clearTimeout(this.userInactiveTimerId);
        this.startUserInactiveTimer();
    }
    startUserInactiveTimer() {
        this.userInactiveTimerId = setTimeout(()=>{
            // State just changed from active to inactive
            this.isActive = false;
            this.onUserActivityStateChange(false);
            // TODO: Task 6915778: Re-evaluate if User Activity telemetry is needed
            this.logger && sendTelemetryEvent(this.logger, {
                eventName: 'UserInactive'
            });
        }, this.timeoutMs);
    }
    /**
   *
   * @param timeoutMs How long to wait for a user activity
   * @param onUserActivityStateChange Handler that will be called with the new state of the user when it changes
   * @param logger Optional logger to track telemetry
   */ constructor(timeoutMs, onUserActivityStateChange, logger){
        this.timeoutMs = timeoutMs;
        this.onUserActivityStateChange = onUserActivityStateChange;
        this.logger = logger;
        this.isActive = true;
        this.userActivityCallback = ()=>{
            this.onUserActivityDetected();
        };
        userActivityEvents.forEach((value)=>{
            document.addEventListener(value, this.userActivityCallback, {
                passive: true,
                capture: false
            });
        });
        this.startUserInactiveTimer();
    }
}
